import { Routes, RouterModule } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';

export const routes: Routes = [
  { path: '', redirectTo: 'modulos', pathMatch: 'full' },
  { path: '**', redirectTo: 'modulos/dashboard' }
];

export const routing: ModuleWithProviders = RouterModule.forRoot(routes, { useHash: false });



// WEBPACK FOOTER //
// /Desenvolvimento/PMP/painel/src/app/app.routing.ts